module.exports = __webpack_public_path__ + "img/sun_2020.8341d639.png";